var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIconBlackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237.4 237.4",
    style: {
      enableBackground: "new 0 0 237.4 237.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 118.8,
    cy: 121.1,
    r: 22.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,80.7c-1.2-3.2-2.8-5.5-5.1-7.9c-2.4-2.4-4.7-3.9-7.9-5.1c-2.4-0.9-6-2-12.7-2.4 c-7.2-0.3-9.4-0.4-27.7-0.4s-20.5,0-27.7,0.4c-6.7,0.3-10.3,1.4-12.7,2.4c-3.2,1.2-5.5,2.8-7.9,5.1c-2.4,2.4-3.9,4.7-5.1,7.9 c-0.9,2.4-2,6-2.4,12.7c-0.3,7.2-0.4,9.4-0.4,27.7s0,20.5,0.4,27.7c0.3,6.7,1.4,10.3,2.4,12.7c1.2,3.2,2.8,5.5,5.1,7.9 c2.4,2.4,4.7,3.9,7.9,5.1c2.4,0.9,6,2,12.7,2.4c7.2,0.3,9.4,0.4,27.7,0.4s20.5,0,27.7-0.4c6.7-0.3,10.3-1.4,12.7-2.4 c3.2-1.2,5.5-2.8,7.9-5.1c2.4-2.4,3.9-4.7,5.1-7.9c0.9-2.4,2-6,2.4-12.7c0.3-7.2,0.4-9.4,0.4-27.7s0-20.5-0.4-27.7 C174.4,86.7,173.2,83.1,172.3,80.7z M118.8,156.4c-19.5,0-35.2-15.8-35.2-35.2S99.4,86,118.8,86c19.5,0,35.2,15.8,35.2,35.2 S138.2,156.4,118.8,156.4z M155.4,92.7c-4.6,0-8.2-3.7-8.2-8.2c0-4.6,3.7-8.2,8.2-8.2c4.6,0,8.2,3.7,8.2,8.2 C163.7,89.1,160,92.7,155.4,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.7,0C53.1,0,0,53.1,0,118.7s53.1,118.7,118.7,118.7s118.7-53.1,118.7-118.7S184.2,0,118.7,0z M187,149.4 c-0.3,7.3-1.5,12.3-3.2,16.7c-1.8,4.5-4.1,8.4-7.9,12.2c-3.8,3.8-7.6,6.2-12.2,7.9c-4.4,1.7-9.4,2.8-16.7,3.2 c-7.3,0.3-9.6,0.4-28.3,0.4s-21-0.1-28.3-0.4s-12.3-1.5-16.7-3.2c-4.5-1.8-8.4-4.1-12.2-7.9c-3.8-3.8-6.2-7.6-7.9-12.2 c-1.7-4.4-2.8-9.4-3.2-16.7c-0.3-7.3-0.4-9.6-0.4-28.3s0.1-21,0.4-28.3s1.5-12.3,3.2-16.7c1.8-4.5,4.1-8.4,7.9-12.2 s7.6-6.2,12.2-7.9c4.4-1.7,9.4-2.8,16.7-3.2c7.3-0.3,9.6-0.4,28.3-0.4s21,0.1,28.3,0.4c7.3,0.3,12.3,1.5,16.7,3.2 c4.5,1.8,8.4,4.1,12.2,7.9c3.8,3.8,6.2,7.6,7.9,12.2c1.7,4.4,2.8,9.4,3.2,16.7s0.4,9.6,0.4,28.3S187.3,142.1,187,149.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconBlackCircle);
export default __webpack_public_path__ + "static/media/instagram-icon-black-circle.8fbdfd678dc6b92d32c2d3d0a06a7984.svg";
export { ForwardRef as ReactComponent };